import { lazy } from 'react';

export const SignUpPageLazy = lazy(() => import('./sign-up-page'));
